/**
 * Clear appliedHash for tenants so apply re-diffs immediately.
 */
export class InvalidateMeteringAppliedRequest {
  tenantIds!: number[];
}
